export const wifiStrength = (signal: number): number => {
  return Math.floor(signal / 30);
};
